import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useRequestEquipmentMutation } from 'api';
import { EquipmentFormValues } from 'types';

import { formValuesAdapter } from '../adapter';

export function useRequestEquipmentForm(onClose?: () => void) {
  const navigate = useNavigate();
  const { requestEquipmentMutation, isLoading, isSuccess } = useRequestEquipmentMutation({});

  const handleSubmit = useCallback(
    async (data: EquipmentFormValues, attachmentIds: string[]) => {
      await requestEquipmentMutation({
        data: {
          ...formValuesAdapter(data),
          ...(!!attachmentIds.length && { file_ids: attachmentIds }),
        },
        userId: data.user,
      });
    },
    [requestEquipmentMutation],
  );

  useEffect(() => {
    if (isSuccess) onClose ? onClose() : navigate(-1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return {
    handleSubmit,
    isLoading,
  };
}
